// Опции гражданства
export const CITIZENSHIP_OPTIONS = [
  { value: 'РФ', label: 'РФ' },
  { value: 'РБ', label: 'Республика Беларусь' },
  { value: 'КЗ', label: 'Казахстан' },
  { value: 'other', label: 'Другое' }
];

// Опции образования
export const EDUCATION_OPTIONS = [
  { value: 'none', label: 'Нет специального образования' },
  { value: 'middle', label: 'Среднее' },
  { value: 'special', label: 'Среднее специальное' },
  { value: 'higher', label: 'Высшее' },
  { value: 'pedagogical', label: 'Высшее педагогическое' }
];

// Опции языков
export const LANGUAGE_OPTIONS = [
  { value: 'russian', label: 'Русский' },
  { value: 'english', label: 'Английский' },
  { value: 'french', label: 'Французский' },
  { value: 'german', label: 'Немецкий' },
  { value: 'spanish', label: 'Испанский' }
];

// Уровни владения языками
export const LANGUAGE_LEVELS = [
  { value: 'native', label: 'Родной' },
  { value: 'C2', label: 'C2 - В совершенстве' },
  { value: 'C1', label: 'C1 - Продвинутый' },
  { value: 'B2', label: 'B2 - Выше среднего' },
  { value: 'B1', label: 'B1 - Средний' },
  { value: 'A2', label: 'A2 - Базовый' },
  { value: 'A1', label: 'A1 - Начальный' }
];

// Опции для выбора пола
export const GENDER_OPTIONS = [
  { value: 'male', label: 'Мальчик' },
  { value: 'female', label: 'Девочка' }
];

// Категории форм
export const FORM_CATEGORIES = {
  NANNY_SEARCH: 'nanny-search',
  TEACHER_SEARCH: 'teacher-search',
  HOUSEKEEPER: 'housekeeper',
  NANNY: 'nanny'
}; 